import React from 'react'
import UserDetailsCard from './UserDetailsCard';

export default function ProfileSetting() {
  return (
    <UserDetailsCard />
  )
}
